export const SUPPORTED_LOCALES = ['en', 'ar'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export const LOCALE_LANGUAGE_NAMES: Record<Locale, string> = {
  en: 'English',
  ar: 'Arabic',
};

export const LOCALE_LANGUAGE_CODES: Record<Locale, string> = {
  en: 'en-US',
  ar: 'ar-SA',
};

export const LOCALE_TEXT_DIRECTION: Record<Locale, 'ltr' | 'rtl'> = {
  en: 'ltr',
  ar: 'rtl',
};

export const normalizeLocale = (value?: string | null): Locale => {
  if (!value) {
    return DEFAULT_LOCALE;
  }
  const normalized = value.trim().toLowerCase();
  if ((SUPPORTED_LOCALES as readonly string[]).includes(normalized)) {
    return normalized as Locale;
  }
  return DEFAULT_LOCALE;
};
